import { AFDCategories, NotValidQuestions } from "./AskForDetails.model";

export const ASK_FOR_DETAIL_LEAVE_PARAM = {
  EXIT: "ASK_FOR_DETAIL_LEAVE_EXIT",
} as const;

export const onShowAFDLeaveAlertHandled = () => {
  const LEAVE_SELL_ALERT = new CustomEvent(ASK_FOR_DETAIL_LEAVE_PARAM.EXIT);
  window.dispatchEvent(LEAVE_SELL_ALERT);
};

export const addStatusToDetails = (detailsToTransform: AFDCategories[]) => {
  return (detailsToTransform || [])?.map(category => ({
    ...category,
    selected: false,
    isValid: true,
    questions: category?.questions?.map(question => ({
      ...question,
      selected: false
    }))
  }));
};

export const resetAllSelected = (details: AFDCategories[]): AFDCategories[] =>
  details.map(category => ({
    ...category,
    selected: false,
    questions: category.questions?.map(question => ({ ...question, selected: false })),
  }));

export const toggleSelection = ( categories: AFDCategories[], categoryIndex: number, questionIndex?: number
): AFDCategories[] => {
  const updatedCategories = [...categories];

  if (questionIndex !== undefined) {
    const question = updatedCategories[categoryIndex]?.questions[questionIndex];
    question.selected = !question?.selected;
  } else {
    const category = updatedCategories[categoryIndex];
    category.selected = !category?.selected;

    if (!category.selected) {
      category.questions.forEach(question => {
        question.selected = false;
      });
    }
  }

  return validateAllQuestions(updatedCategories);
};

export const selectQuestion = ( categories: AFDCategories[], categoryIndex: number, ): AFDCategories[] => {
  const updatedCategories = [...categories];
  const question = updatedCategories[categoryIndex];
  question.selected = true;
  
  return updatedCategories;
};

export const anyQuestionSelected = (categories: AFDCategories[]): boolean => {
    return categories?.some(
      (ask) => ask?.selected,
    );
};

export function filterAndRemoveSelected(categories: AFDCategories[]): { categories: AFDCategories[] } {
  const filteredCategories = categories
    .filter(category => category?.selected)
    .map(category => {
      const filteredQuestions = category?.questions?.filter(question => question?.selected).map(question => {
        const { selected, ...rest } = question;
        return rest;
      }) || [];

      const { selected, isValid, ...restCategory } = category;
      return { ...restCategory, questions: filteredQuestions };
    });

  return { categories: filteredCategories };
}

export const findInvalidQuestions = (categories: AFDCategories[], inputOfferPrice?: string): NotValidQuestions => {
  let invalidQuestionsCount = 0;
  const updatedCategories = categories?.map(category => {
    if (category.selected && category?.questions?.length > 0) {
      const anyQuestionSelected = category?.questions?.some(
        subQuestion => subQuestion?.selected,
      );
      if (!anyQuestionSelected) {
        category.isValid = false;
        invalidQuestionsCount++;
      }
    }
    return category;
  });

  return { updatedCategories, invalidQuestionsCount };
};

export const validateAllQuestions = (categories: AFDCategories[]) => {
  const validatedCategories = categories?.map((category) => {
    if (category?.selected) {
      if (category?.questions?.length > 0) {
        const isAnySubQuestionSelected = category?.questions?.some(
          (subQuestion) => subQuestion?.selected,
        );
        if (isAnySubQuestionSelected) {
          category.isValid = true;
        }
      }
    } else {
      category.isValid = true;
    }
    return category;
  });

  return validatedCategories;
};